export default "__VITE_ASSET__BY$dD1eq__"